function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.700000, 0.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  id: "noun_sorting_368361-(1)"
}, React.createElement("path", {
  d: "M0.211756036,2.80042797 L2.37189157,0.447495392 C2.61834998,0.179039998 2.99528638,0.179039998 3.2417448,0.447495392 L5.40188033,2.80042797 C5.72082651,3.14784083 5.67733385,3.7479176 5.2858999,4.03216448 C4.99594882,4.2374539 4.59001731,4.17428793 4.34355889,3.90583253 L3.53169588,3.02150888 L3.53169588,10.5177107 C3.53169588,10.9598726 3.19825214,11.3230769 2.79232063,11.3230769 C2.38638912,11.3230769 2.05294538,10.9598726 2.05294538,10.5177107 L2.05294538,3.03730037 L1.27007747,3.90583253 C1.02361905,4.17428793 0.632185099,4.2374539 0.327736468,4.03216448 C-0.0636974874,3.7479176 -0.107190149,3.14784083 0.211756036,2.80042797 Z",
  id: "Shape"
}))), React.createElement("g", {
  id: "Group-2-Copy-2",
  transform: "translate(9.586364, 9.630769) scale(1, -1) translate(-9.586364, -9.630769) translate(6.736364, 3.630769)"
}, React.createElement("g", {
  id: "noun_sorting_368361-(1)"
}, React.createElement("path", {
  d: "M0.211756036,2.80042797 L2.37189157,0.447495392 C2.61834998,0.179039998 2.99528638,0.179039998 3.2417448,0.447495392 L5.40188033,2.80042797 C5.72082651,3.14784083 5.67733385,3.7479176 5.2858999,4.03216448 C4.99594882,4.2374539 4.59001731,4.17428793 4.34355889,3.90583253 L3.53169588,3.02150888 L3.53169588,10.5177107 C3.53169588,10.9598726 3.19825214,11.3230769 2.79232063,11.3230769 C2.38638912,11.3230769 2.05294538,10.9598726 2.05294538,10.5177107 L2.05294538,3.03730037 L1.27007747,3.90583253 C1.02361905,4.17428793 0.632185099,4.2374539 0.327736468,4.03216448 C-0.0636974874,3.7479176 -0.107190149,3.14784083 0.211756036,2.80042797 Z",
  id: "Shape"
})))));

const SvgSort = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sort.7e3a7351.svg";
export { ForwardRef as ReactComponent };